(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gazali-header"]) return;
  try {
    
import('@shopify/events').then(({ StandardEvents }) => {
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (Number.isFinite(count)) document.querySelectorAll('[data-gz-cart-count]').forEach(el => { el.textContent = String(count); });
    }).catch(() => {});
  });
}).catch(() => {});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jomlax-collection-directory"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input', event => {
  if (!event.target.matches('[data-jm-category-search]')) return;
  const section = event.target.closest('.jm-directory');
  const normalize = value => value.normalize('NFKD').replace(/[ً-ٰٟـ]/g, '').replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').toLowerCase().trim();
  const query = normalize(event.target.value);
  let matches = 0;
  section.querySelectorAll('[data-jm-category-name]').forEach(card => {card.hidden = !normalize(card.dataset.jmCategoryName).includes(query); if (!card.hidden) matches++;});
  section.querySelector('.jm-category-no-results').hidden = matches > 0;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
